(() => {
  const strings = window.koflerBundlePriceStrings;
  const cache = window.koflerBundlePriceCache;
  const states = new WeakMap();
  if (!strings || !cache) return;

  const money = new Intl.NumberFormat(document.documentElement.lang || 'de', {
    style: 'currency',
    currency: strings.currency,
  });

  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };
  const formatted = (price) => {
    const value = price.formatted || money.format(price.amount / 100);
    return strings.showCurrency ? `${value} ${strings.currency}` : value;
  };

  function render(state) {
    const { block, detail, host } = state;
    if (!block.isConnected || !host.isConnected) return;
    const pricing = detail.pricing;
    if (!pricing?.discountedPrice || !pricing.fullPrice) return;
    const current = pricing.discountedPrice;
    const original = pricing.fullPrice;
    if (![current.amount, original.amount].every(Number.isFinite)) return;
    const price = host.querySelector('.price');
    if (!price) return;

    const quantity = (detail.variantIdQuantities || []).reduce((sum, item) => sum + item.quantity, 0);
    const saving = Math.max(0, original.amount - current.amount);
    price.classList.toggle('price--on-sale', saving > 0);
    if (saving > 0) price.classList.remove('price--no-compare');
    setText(price.querySelector('.price__regular .price-item--regular'), formatted(current));
    setText(price.querySelector('.price__sale .price-item--sale'), formatted(current));
    setText(price.querySelector('.price__sale s.price-item--regular'), saving > 0 ? formatted(original) : '');

    const summary = price.querySelector('[data-discount-summary]');
    if (summary) {
      setText(summary.querySelector('[data-discount-badge]'), saving > 0
        ? (Math.round(saving / original.amount * 100) > 0
          ? `-${Math.round(saving / original.amount * 100)}%` : '<1%') : '');
      setText(summary.querySelector('[data-discount-savings]'), saving > 0
        ? strings.discountSavings.replace('__AMOUNT__', money.format(saving / 100)) : '');
      summary.hidden = saving <= 0;
    }

    let meta = price.querySelector('.kofler-bundle-price-meta');
    if (!meta) {
      meta = document.createElement('div');
      meta.className = 'kofler-bundle-price-meta';
      const quantityLabel = document.createElement('span');
      quantityLabel.className = 'kofler-bundle-price-quantity';
      meta.append(quantityLabel);
      price.append(meta);
    }
    const quantityLabel = meta.querySelector('.kofler-bundle-price-quantity');
    const perItemAmount = Number.isFinite(pricing.discountedPricePerItem?.amount)
      ? pricing.discountedPricePerItem.amount : current.amount / quantity;
    const showPerItem = quantity > 1 && Number.isFinite(perItemAmount) && perItemAmount >= 0;
    setText(quantityLabel, showPerItem
      ? strings.perItem.replace('__AMOUNT__', money.format(perItemAmount / 100)) : '');
    quantityLabel.hidden = !showPerItem;
    meta.hidden = !showPerItem;

    // Use the app's unit price as well; the native per-kg price is for a single full-price item.
    const selectedBar = block.querySelector('.kaching-bundles__bar--selected');
    const unitText = selectedBar?.querySelector('.kaching-bundles__bar-unit-price')
      ?.textContent.replace(/\s+/g, ' ').trim() || '';
    const nativeUnit = price.querySelector('.unit-price');
    if (nativeUnit) {
      if (!nativeUnit.hasAttribute('data-kofler-originally-hidden')) {
        nativeUnit.dataset.koflerOriginallyHidden = String(nativeUnit.classList.contains('hidden'));
      }
      nativeUnit.classList.toggle('hidden', !!unitText || quantity > 1
        || nativeUnit.dataset.koflerOriginallyHidden === 'true');
    }
    let unitLabel = price.querySelector('.kofler-bundle-unit-price');
    if (!unitLabel && unitText) {
      unitLabel = document.createElement('small');
      unitLabel.className = 'kofler-bundle-unit-price';
      price.append(unitLabel);
    }
    if (unitLabel) {
      setText(unitLabel, unitText);
      unitLabel.hidden = !unitText;
    }
  }

  function update(block, detail) {
    const productInfo = block.closest('product-info');
    const host = productInfo?.querySelector('[id^="price-"]');
    if (!host || !detail?.pricing) return;
    let state = states.get(host);
    if (!state) {
      state = { block, detail, host, scheduled: false };
      // Variant changes replace the price markup, so reapply the latest app price afterwards.
      const observer = new MutationObserver(() => {
        if (state.scheduled) return;
        state.scheduled = true;
        requestAnimationFrame(() => {
          state.scheduled = false;
          render(state);
        });
      });
      observer.observe(host, { childList: true, subtree: true, characterData: true });
      states.set(host, state);
    }
    state.block = block;
    state.detail = detail;
    render(state);
  }

  document.addEventListener('variants-changed', (event) => {
    if (event.target.localName === 'kaching-bundles-block') update(event.target, event.detail);
  }, true);

  document.querySelectorAll('kaching-bundles-block').forEach((block) => {
    const detail = cache.get(block);
    if (detail) update(block, detail);
  });
})();
